/**
 * Engine Configuration
 * Platform-agnostic configuration class
 */

import { FacebetterError } from './errors.js';

/**
 * Engine configuration class
 * Similar to EngineConfig struct in C++/Java/OC
 */
export class EngineConfig {
  /**
   * Creates a new EngineConfig instance
   * @param {Object} config - Configuration object
   * @param {string} [config.appId] - Application ID (required if licenseJson is not provided)
   * @param {string} [config.appKey] - Application key (required if licenseJson is not provided)
   * @param {string} [config.licenseJson] - License JSON string (optional, if provided, appId and appKey are not required)
   */
  constructor(config = {}) {
    this.appId = config.appId || null;
    this.appKey = config.appKey || null;
    this.licenseJson = config.licenseJson || null;
    this.resourcePath = '/facebetter/resource.bundle';
  }

  /**
   * Validates the configuration
   * @returns {boolean} True if valid
   */
  isValid() {
    // 如果提供了 licenseJson，则使用授权数据验证
    if (this.licenseJson) {
      return typeof this.licenseJson === 'string' && this.licenseJson.trim() !== '';
    }
    // 否则需要 appId 和 appKey
    return this.appId && typeof this.appId === 'string' && this.appId.trim() !== '' &&
           this.appKey && typeof this.appKey === 'string' && this.appKey.trim() !== '';
  }

  /**
   * Returns a string representation of the config
   * @returns {string} String representation
   */
  toString() {
    return `EngineConfig{appId='${this.appId ? this.appId.substring(0, Math.min(this.appId.length, 8)) + '...' : 'null'}', appKey='${this.appKey ? '***' : 'null'}', licenseJson=${this.licenseJson ? 'provided' : 'null'}}`;
  }
}

